var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeroku = function SvgHeroku(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 40 2 L 12 2 C 9.242188 2 7 4.242188 7 7 L 7 43 C 7 45.757813 9.242188 48 12 48 L 40 48 C 42.757813 48 45 45.757813 45 43 L 45 7 C 45 4.242188 42.757813 2 40 2 Z M 16.558594 40.914063 L 16.558594 30.964844 L 21.535156 35.941406 Z M 35.261719 40.945313 L 30.496094 40.945313 L 30.496094 23.472656 C 30.496094 23.472656 31.632813 19.289063 16.496094 25.183594 C 16.46875 25.257813 16.46875 9.023438 16.46875 9.023438 L 21.414063 8.996094 L 21.414063 19.394531 C 21.414063 19.394531 35.261719 13.941406 35.261719 23.53125 Z M 33.3125 15.289063 L 28.066406 15.289063 C 29.957031 12.980469 31.664063 9.023438 31.664063 9.023438 L 37.089844 9.023438 C 37.089844 9.023438 36.160156 11.601563 33.3125 15.289063 Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeroku, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heroku.47125dca.svg";
export { ForwardRef as ReactComponent };